module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SWIFT-BOOSTER-GREEN-5.293dd569.jpg";